import { render, staticRenderFns } from "./contractsWidget.vue?vue&type=template&id=eebcfc0a&"
import script from "./contractsWidget.vue?vue&type=script&lang=js&"
export * from "./contractsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports